;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { FormFeedback, Label } from 'reactstrap';
import MaskedInput from 'react-text-mask';
import { Dictionaries } from '../../../i18n/i18n-config';
import { getI18nUtils } from '../../../i18n/i18n-utils';

interface FormikMaskedInputProps {
  type: string;
  name: string;
  formik: any;
  intlKey?: string;
  id?: string;
  required?: boolean;
  className?: string;
  pattern: any;
  placeholder: string;
  dictionary: Partial<Dictionaries>;
}

function FormikMaskedInput(props: FormikMaskedInputProps): JSX.Element {
  const { className, type, name, id, required, intlKey, formik, pattern, placeholder, dictionary } = props;
  const { formatMessage } = getI18nUtils(dictionary);
  const { touched, error } = formik.getFieldMeta(name);

  const invalid = touched && error;

  return (
    <div className={className || ''}>
      <Label for={name} className={required ? 'required' : ''}>
        {formatMessage({ id: intlKey || name })}
      </Label>

      <MaskedInput
        className={`form-control${invalid ? ' is-invalid' : ''}`}
        mask={pattern}
        placeholder={placeholder}
        invalid={invalid}
        type={type}
        name={name}
        id={id || name}
        {...formik.getFieldProps(`${name}`)}
      />
      {error && <FormFeedback>{formatMessage({ id: error })}</FormFeedback>}
    </div>
  );
}

export default FormikMaskedInput;
